module.exports = __webpack_public_path__ + "static/WEDDING E&M-99-c109608e947c34cc98ca1fddd1ccb97d.jpg";